/*=========================================================================================
  File Name: moduleAccounts.js
  Description: Accounts Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./moduleAccountsState.js"
import mutations from "./moduleAccountsMutations.js"
import actions from "./moduleAccountsActions.js"
import getters from "./moduleAccountsGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

